import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import {
	PortalOneColumnLayout,
	CenteredPortalPage,
	PageTitle,
	PortalPageSection,
	ButtonsSection,
} from 'components/PortalStructure';
import { Button, LoadingOverlayWrapper, ErrorSummary } from 'components';
import { FileUpload } from 'components/FormControls';
import { browserHistory } from 'react-router';
import { IActionData } from 'models/common';
import { downloadCSVSample } from 'redux/modules/product/productsimportimages';
const { connect } = require('react-redux');
require('./style.css');

interface IParams {
	id?: string;
}

interface IState extends IActionData {
	showImportLoader: boolean;
}

interface IProps {
	params?: IParams;
	dispatch?: any;
	downloadCSVSample?: () => void;

	/* functions props */
	t?: (key: string, object?: any) => string;
}

@connect((dispatch) => ({
	dispatch,
	downloadCSVSample: () => dispatch(downloadCSVSample()),
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ImportProducts extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			showImportLoader: false,
		};

		this.productsCsvFileUploaded = this.productsCsvFileUploaded.bind(this);
		this.productsCsvFileUploadFailed = this.productsCsvFileUploadFailed.bind(this);
		this.displayImportLoader = this.displayImportLoader.bind(this);
		this.renderTextWithLinkToDownloadTemplate = this.renderTextWithLinkToDownloadTemplate.bind(this);
		this.downloadCSVSample = this.downloadCSVSample.bind(this);
	}

	private renderTextWithLinkToDownloadTemplate(resource: string) {
		const regex = new RegExp(/\[\[linkToDownloadTemplate\]\]/);
		return (
			<div className="title">
				{resource.split(regex).reduce((prev, current, i) => {
					if (!i) {
						return [current];
					}

					const element = (
						<a key={i} href="#" onClick={(e) => this.downloadCSVSample(e)} target="_blank">
							{this.props.t('Shop_ManageShop_Products_Import_Text1_LinkText')}
						</a>
					);
					return prev.concat([element, current]);
				}, [])}
			</div>
		);
	}

	private downloadCSVSample(e) {
		e.preventDefault();
		this.props.downloadCSVSample();
	}

	public productsCsvFileUploaded() {
		browserHistory.push(`/shop/${this.props.params.id}/edit/products`);
	}

	public productsCsvFileUploadFailed(error: any) {
		if (error) {
			this.setState({
				error: true,
				message: error,
			});
			this.forceUpdate();
		}
	}

	private displayImportLoader(display: boolean) {
		this.setState({
			showImportLoader: display,
		});
		this.forceUpdate();
	}

	public render() {
		const { t, params, dispatch } = this.props;
		const { showImportLoader, error, message } = this.state;

		const errorSummaryProps = {
			error,
			message,
		};

		return (
			<PortalOneColumnLayout>
				<CenteredPortalPage>
					<PageTitle usage="centeredPage" title={t('Shop_ManageShop_Products_Import_Label_ImportProducts')} />
					<LoadingOverlayWrapper
						active={showImportLoader}
						spinner={true}
						text={t('BSPortal_Common_Loading')}
						background="rgba(0, 0, 0, 0.1)"
					>
						<div className="importProductsContainer">
							<ErrorSummary {...errorSummaryProps} />
							<PortalPageSection>
								<div className="importTextSilver">{t('Shop_ManageShop_Products_Import_Label_ImportProducts_Desc')}</div>
								<div className={`borderBottom" importTextSilver`}>
									{this.renderTextWithLinkToDownloadTemplate(t('Shop_ManageShop_Products_Import_Text1'))}
								</div>

								<ul className="listText">
									<li>
										<div>{t('Shop_ManageShop_Products_Import_Text2')}</div>
									</li>
									<li>
										<div
											dangerouslySetInnerHTML={{
												__html: t('Shop_ManageShop_Products_Import_Text3', { shopId: params.id }),
											}}
										/>
									</li>
								</ul>
							</PortalPageSection>
							<ButtonsSection>
								<div className="row">
									<div className="col-sm-12">
										<Button
											type="button"
											onClick={() => {
												browserHistory.push(`/shop/${this.props.params.id}/edit/products`);
											}}
										>
											{t('BSPortal_Common_Cancel')}
										</Button>
										<FileUpload
											name="productsCsvUpload"
											fileUploadedCallback={this.productsCsvFileUploaded}
											fileUploadFailed={this.productsCsvFileUploadFailed}
											acceptFileTypes=".csv"
											apiUrl="api/Product/CsvUpload"
											shopId={this.props.params.id}
											isMultiple={false}
											isButton={true}
											buttonText={t('BSPortal_Common_Import')}
											showLoader={() => {
												this.displayImportLoader(true);
											}}
											hideLoader={() => {
												this.displayImportLoader(false);
											}}
											dispatch={dispatch}
										/>
										<div className="clear" />
										<div className="clear" />
									</div>
								</div>
							</ButtonsSection>
						</div>
					</LoadingOverlayWrapper>
				</CenteredPortalPage>
			</PortalOneColumnLayout>
		);
	}
}

export { ImportProducts };
